<template>
  <b-card class="rounded">
    <b-card-title v-if="description"> Confidence Level </b-card-title>
    <b-card-sub-title v-if="description" class="mb-3">
      Порог принятия рещения по отсечению виртуального ассистента (ВА)
    </b-card-sub-title>
    <b-form-input
      id="range-1"
      v-model="value"
      type="range"
      min="7"
      max="14"
    ></b-form-input>
    <div class="mt-2">Value: {{ value }}</div>
    <div id="description">
      <b-col v-if="value <= 9" class="mt-2">
        <b-row class="mb-2 mt-2">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM5 15H7C7 14.2044 7.31607 13.4413 7.87868 12.8787C8.44129 12.3161 9.20435 12 10 12C10.7956 12 11.5587 12.3161 12.1213 12.8787C12.6839 13.4413 13 14.2044 13 15H15C15 13.6739 14.4732 12.4021 13.5355 11.4645C12.5979 10.5268 11.3261 10 10 10C8.67392 10 7.40215 10.5268 6.46447 11.4645C5.52678 12.4021 5 13.6739 5 15ZM6 9C6.39782 9 6.77936 8.84196 7.06066 8.56066C7.34196 8.27936 7.5 7.89782 7.5 7.5C7.5 7.10218 7.34196 6.72064 7.06066 6.43934C6.77936 6.15804 6.39782 6 6 6C5.60218 6 5.22064 6.15804 4.93934 6.43934C4.65804 6.72064 4.5 7.10218 4.5 7.5C4.5 7.89782 4.65804 8.27936 4.93934 8.56066C5.22064 8.84196 5.60218 9 6 9ZM14 9C14.3978 9 14.7794 8.84196 15.0607 8.56066C15.342 8.27936 15.5 7.89782 15.5 7.5C15.5 7.10218 15.342 6.72064 15.0607 6.43934C14.7794 6.15804 14.3978 6 14 6C13.6022 6 13.2206 6.15804 12.9393 6.43934C12.658 6.72064 12.5 7.10218 12.5 7.5C12.5 7.89782 12.658 8.27936 12.9393 8.56066C13.2206 8.84196 13.6022 9 14 9Z"
              fill="#FF455E"
            />
          </svg>
          <span class="ml-3">Confidence Level — низкий.</span></b-row
        >
        <b-row v-if="description"
          ><span
            >Практически все ВА будут отсечены, но и вероятность ошибочного
            принятия человека за ВА тоже становится выше.</span
          ></b-row
        >
      </b-col>

      <b-col v-else-if="value < 12" class="mt-2">
        <b-row class="mb-2 mt-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM7 13C7 14.3261 7.52678 15.5979 8.46447 16.5355C9.40215 17.4732 10.6739 18 12 18C13.3261 18 14.5979 17.4732 15.5355 16.5355C16.4732 15.5979 17 14.3261 17 13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H7ZM8 11C8.39782 11 8.77936 10.842 9.06066 10.5607C9.34196 10.2794 9.5 9.89782 9.5 9.5C9.5 9.10218 9.34196 8.72064 9.06066 8.43934C8.77936 8.15804 8.39782 8 8 8C7.60218 8 7.22064 8.15804 6.93934 8.43934C6.65804 8.72064 6.5 9.10218 6.5 9.5C6.5 9.89782 6.65804 10.2794 6.93934 10.5607C7.22064 10.842 7.60218 11 8 11ZM16 11C16.3978 11 16.7794 10.842 17.0607 10.5607C17.342 10.2794 17.5 9.89782 17.5 9.5C17.5 9.10218 17.342 8.72064 17.0607 8.43934C16.7794 8.15804 16.3978 8 16 8C15.6022 8 15.2206 8.15804 14.9393 8.43934C14.658 8.72064 14.5 9.10218 14.5 9.5C14.5 9.89782 14.658 10.2794 14.9393 10.5607C15.2206 10.842 15.6022 11 16 11Z"
              fill="#0063F7"
            />
          </svg>

          <span class="ml-3">Confidence Level — средний.</span></b-row
        >
        <b-row v-if="description"
          ><span
            >Достигнут баланс между уровнем отсеченных ВА и количеством
            ошибок</span
          ></b-row
        >
      </b-col>

      <b-col v-else class="mt-2">
        <b-row class="mb-2 mt-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_58_15712)">
              <path
                d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM8 13C8 14.0609 8.42143 15.0783 9.17157 15.8284C9.92172 16.5786 10.9391 17 12 17C13.0609 17 14.0783 16.5786 14.8284 15.8284C15.5786 15.0783 16 14.0609 16 13H8ZM8 11C8.39782 11 8.77936 10.842 9.06066 10.5607C9.34196 10.2794 9.5 9.89782 9.5 9.5C9.5 9.10218 9.34196 8.72064 9.06066 8.43934C8.77936 8.15804 8.39782 8 8 8C7.60218 8 7.22064 8.15804 6.93934 8.43934C6.65804 8.72064 6.5 9.10218 6.5 9.5C6.5 9.89782 6.65804 10.2794 6.93934 10.5607C7.22064 10.842 7.60218 11 8 11ZM16 11C16.3978 11 16.7794 10.842 17.0607 10.5607C17.342 10.2794 17.5 9.89782 17.5 9.5C17.5 9.10218 17.342 8.72064 17.0607 8.43934C16.7794 8.15804 16.3978 8 16 8C15.6022 8 15.2206 8.15804 14.9393 8.43934C14.658 8.72064 14.5 9.10218 14.5 9.5C14.5 9.89782 14.658 10.2794 14.9393 10.5607C15.2206 10.842 15.6022 11 16 11Z"
                fill="#00F7BF"
              />
            </g>
            <defs>
              <clipPath id="clip0_58_15712">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <span class="ml-3">Confidence Level — высокий.</span></b-row
        >
        <b-row v-if="description"
          ><span
            >Система отсекает ВА только если уверена, что это именно ВА, а не
            человек. При высоком Confidence Level практически нет ошибок второго
            типа, когда система приняла человека за ВА, но при этом некоторое
            количество ВА все же будет попадать на операторов.</span
          ></b-row
        >
      </b-col>
    </div>
  </b-card>
</template>

<script>
import {
  BFormInput,
  BCard,
  BCardTitle,
  BCardSubTitle,
  BRow,
  BCol,
} from "bootstrap-vue";

export default {
  props: ["description", "default"],
  data() {
    return {
      value: this.default,
    };
  },
  components: {
    BFormInput,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BRow,
    BCol,
  },
  watch: {
    value: function (val) {
      this.$emit("save-confidence-settings", val);
    },
    default() {
      this.value = this.default ? this.default : 12;
      this.$emit("save-confidence-settings", this.value);
    },
  },
};
</script>
